import {UI} from "../../../../../../stem-core/src/ui/UIBase.js";

import {styleRule, styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme.js";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService.js";
import {Flow} from "../../../../flows/Flow.js";
import {Messages} from "../../../../../Messages.js";
import {Link} from "../../../../../../stem-core/src/ui/primitives/Link.jsx";
import {INLINE_EDIT_DONATION_URLS} from "../../../../PanelConstants.js";
import {PaymentMethodAcceptOrChange} from "../../payment-method/components/PaymentMethodAcceptOrChange.jsx";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore.js";
import {DonationStore} from "../../../../../../client/state/DonationStore.js";
import {BasePanelPage, BasePanelPageStyle} from "../../../../PanelPage.jsx";
import {DonationAmountAndFrequency} from "../components/DonationAmountAndFrequency.jsx";
import {autoredraw} from "../../../../../../stem-core/src/decorators/AutoRedraw.js";
import {MessageElement} from "../../../../../widget/ui/MessageElement.jsx";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService.js";
import {BlinkButton} from "../../../../../../core/ui/Button.jsx";


class EditDonationPanelStyle extends BasePanelPageStyle {
    @styleRule
    description = {
        display: "inline",
    };

    @styleRuleInherit
    body = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    }
}

@autoredraw(PaymentMethodStore, DonationStore)
@registerStyle(EditDonationPanelStyle)
export class EditDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editRecurringDonation,
        };
    }

    isButtonDisabled() {
        if (!Flow.donationDetails.isValid()) {
            return true;
        }
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        return (Flow.donationDetails.getTotalAmount() === donation.amount)
            && (donation.getPaymentMethod() === Flow.paymentMethod.selectedValue);
    }

    render() {
        const {styleSheet} = this;
        const activeDonation = iFrameUserDataService.getActiveRecurringDonation();

        return [
            <div>
                <MessageElement
                    className={styleSheet.description}
                    message={Messages.donatePageRecurringDonationMessage(activeDonation.formatPrice())}
                />
                <Link
                    value={Messages.here}
                    style={{display: "inline-block"}}
                    href={INLINE_EDIT_DONATION_URLS.cancel}
                />.
            </div>,

            !iFrameMerchantService.isCDSPaymentMethod() && <PaymentMethodAcceptOrChange style={{marginTop: 12, marginBottom: 12}} />,

            <DonationAmountAndFrequency
                ref="editDonationComponent"
                onChange={() => this.redraw()}
            />,

            <BlinkButton
                ref="button"
                label={Flow.donationDetails.getEditDonationComponentButtonLabel()}
                disabled={this.isButtonDisabled()}
                onClick={() => Flow.donation.updateDonation()}
                className={styleSheet.actionButton}
            />,
        ];
    }
}
